// The console's entry: fonts (self-hosted, D74), styles (Console D's tokens, base, legacy and
// components from @apsio/ui, then src/styles, in cascade order), the query client and the router.
import '@fontsource/ibm-plex-mono/400.css'
import '@fontsource/ibm-plex-mono/500.css'
import '@fontsource/ibm-plex-mono/600.css'
import '@fontsource/public-sans/400.css'
import '@fontsource/public-sans/500.css'
import '@fontsource/public-sans/600.css'
import '@fontsource/public-sans/700.css'
import '@fontsource/schibsted-grotesk/600.css'
import '@fontsource/schibsted-grotesk/700.css'
import '@fontsource/schibsted-grotesk/800.css'
import '@apsio/ui/tokens.css'
import '@apsio/ui/base.css'
import './styles/legacy.css'
import './styles/bar.css'
import '@apsio/ui/components.css'
import './styles/replay.css'
import '@apsio/ui/shell.css'
import './styles/session.css'
import './styles/sessions.css'
import './styles/journeys.css'
import './styles/logs.css'
import './styles/issues.css'
import '@apsio/ui/entry.css'
import './styles/perf.css'
import './styles/agents.css'
import './styles/settings.css'
import './styles/health.css'
import './styles/setup.css'
import './styles/home.css'
import './styles/instrumentation.css'
import './styles/signals.css'
import './styles/dashboards.css'
import './styles/alerts.css'
import './styles/flags.css'
import './styles/people.css'
import './styles/explore.css'
import './styles/releases.css'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from '@tanstack/react-router'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { isApiError } from './api/client'
import { installProbe } from './lib/e2eProbe'
import { applyRail, readRail } from './lib/rail'
import { takeSignupHandoff } from './lib/signupHandoff'
import { makeRouter } from './router'

// The site's hand-off leaves /signup's address before the router or PostHog can read it.
takeSignupHandoff()

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Errors with a status (401, 403, 404) are answers, not glitches: no retry.
      retry: (count, error) => !isApiError(error) && count < 2,
      refetchOnWindowFocus: false,
    },
  },
})
const router = makeRouter(queryClient)
// The end-to-end timing probe, in builds made for E2E_PROBE=1 only (APS-236).
if (import.meta.env.VITE_E2E_PROBE === '1') installProbe(queryClient)
// The folded sidebar, before the first paint (the CSP allows no inline script to do it earlier).
applyRail(readRail())

const root = document.getElementById('root')
if (root)
  createRoot(root).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </StrictMode>,
  )
